import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "repayment-type-selection"
}
const _hoisted_2 = { class: "sc-desc" }
const _hoisted_3 = {
  key: 0,
  class: "buttons",
  id: "repayment-type-buttons"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "button-text" }
const _hoisted_6 = {
  class: "section",
  id: "repayment-type-description"
}
const _hoisted_7 = {
  class: "section",
  id: "estimated-payments"
}
const _hoisted_8 = { class: "payments" }
const _hoisted_9 = { class: "payment" }
const _hoisted_10 = { class: "payment" }

import { ref, computed } from "vue";
import { useStore } from "vuex";
import type {
  RatePlanVM,
  RepaymentTermOption,
  RepaymentTypeOption,
} from "@/models/loanConfiguration";


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentTypeSelection',
  props: {
    repaymentTerm: {}
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();

const props = __props;

const selectedRepaymentTypeId = ref<number>(0);

const repaymentTypeOptions = computed<RepaymentTypeOption[]>(
  () => props.repaymentTerm?.repaymentTypeOptions ?? [],
);

const isValidRepaymentType = computed<boolean>(() => selectedRepaymentType.value !== undefined);

const selectedRepaymentType = computed<RepaymentTypeOption | undefined>(() => {
  if (repaymentTypeOptions.value) {
    return repaymentTypeOptions.value?.find(
      (r: RepaymentTypeOption) => r.repaymentTypeId === selectedRepaymentTypeId.value,
    );
  }

  return undefined;
});

const selectedRatePlan = computed<RatePlanVM | undefined>(() => {
  if (props.repaymentTerm) {
    return props.repaymentTerm.ratePlans.find(
      (r: RatePlanVM) => r.id === selectedRepaymentType.value?.ratePlanId,
    );
  }
  return undefined;
});

const monthlyInSchoolPaymentLabel = computed<string>(
  () => store.state.loanConfigurationModule?.loanOptionsConfiguration?.monthlyInSchoolPaymentLabel,
);

const monthlyPostSchoolPaymentLabel = computed<string>(
  () =>
    store.state.loanConfigurationModule?.loanOptionsConfiguration?.monthlyPostSchoolPaymentLabel,
);

const ratePlanRepaymentTypes = computed(() => {
  return selectedRatePlan.value?.repayments;
});

function selectRepaymentType(repaymentTypeId: number) {
  selectedRepaymentTypeId.value = repaymentTypeId;
}

function resetSelectedRepaymentType() {
  selectedRepaymentTypeId.value = 0;
}

__expose({
	isValidRepaymentType,
  monthlyInSchoolPaymentLabel,
  monthlyPostSchoolPaymentLabel,
  props,
  ratePlanRepaymentTypes,
  resetSelectedRepaymentType,
  repaymentTypeOptions,
  selectedRatePlan,
  selectedRepaymentTypeId,
  selectedRepaymentType,
  selectRepaymentType,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "title" }, "What type of repayment works best for you?", -1)),
    _createElementVNode("p", _hoisted_2, " There are " + _toDisplayString(__props.repaymentTerm?.numberOfRepaymentTypes) + " repayment options to select from. Choose a repayment type to learn more and see estimated monthly payments. You will be able to review and edit your selections on the next page. ", 1),
    (__props.repaymentTerm && repaymentTypeOptions.value?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repaymentTypeOptions.value, (repaymentTypeOption) => {
            return (_openBlock(), _createElementBlock("button", {
              key: repaymentTypeOption?.repaymentTypeId || '',
              class: _normalizeClass(["repayment-type-button", [{ active: repaymentTypeOption.repaymentTypeId === selectedRepaymentTypeId.value }]]),
              onClick: ($event: any) => (selectRepaymentType(repaymentTypeOption.repaymentTypeId || 0))
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(repaymentTypeOption?.repaymentTypeDetails?.name || repaymentTypeOption.repaymentTypeName), 1)
            ], 10, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["sections", { hasSelection: selectedRepaymentTypeId.value > 0 }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h5", null, _toDisplayString(selectedRepaymentType.value?.repaymentTypeName || "Repayment Type"), 1),
        _createElementVNode("p", null, _toDisplayString(selectedRepaymentType.value
              ? selectedRepaymentType.value?.repaymentTypeDetails?.description
              : "Select a repayment type to learn more."), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Estimated Monthly Payments", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(monthlyInSchoolPaymentLabel.value), 1),
            _createElementVNode("p", null, _toDisplayString(selectedRepaymentType.value?.monthlyInSchoolPaymentDisplay || "—"), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", null, _toDisplayString(monthlyPostSchoolPaymentLabel.value), 1),
            _createElementVNode("p", null, _toDisplayString(selectedRepaymentType.value?.monthlyPostSchoolPaymentDisplay || "—"), 1)
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})